import { useMemo } from 'react'

import { useOpenWindow } from '@krp/client-runtime'
import {
  PLATFORM_WINDOWS,
  ResourcesScreen,
  makeSelectResourcesVm,
  platformResources,
  resourcesReloadRequested,
  type ResourcesActions,
} from '@krp/platform-ui'

import { useAppDispatch, useAppSelector } from '../../app/hooks'
import type { RootState } from '../../app/types'
import { CONNECTION_FORMS } from '../../composition/connectionForms'
import { useMyAccess } from './useMyAccess'

/**
 * Binding вкладки «Источники»: единственное место, где видна форма RootState для этой фичи. Подписывает запрос
 * реестра, собирает vm именованным селектором пакета и отдаёт экрану vm + actions. Экран store не знает. Состояния
 * вкладки нет: список — кэш запроса, фильтров нет, что открыто — в адресе окна.
 */
export function ResourcesBinding() {
  const dispatch = useAppDispatch()
  const openWindow = useOpenWindow()
  platformResources.useQuerySubscription()
  const access = useMyAccess()

  const selectVm = useMemo(() => {
    const selectPackageVm = makeSelectResourcesVm()
    const selectQuery = platformResources.select()
    return (state: RootState) => selectPackageVm({ query: selectQuery(state), access, forms: CONNECTION_FORMS })
  }, [access])
  const vm = useAppSelector(selectVm)

  const actions = useMemo<ResourcesActions>(
    () => ({
      reload: () => dispatch(resourcesReloadRequested({ resourceId: null })),
      open: (resourceId) => openWindow(PLATFORM_WINDOWS.resource, { rid: resourceId }),
      add: () => openWindow(PLATFORM_WINDOWS.sourceAdd),
    }),
    [dispatch, openWindow],
  )

  return <ResourcesScreen vm={vm} actions={actions} />
}
